import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["trigger", "showDelay", "hideDelay", "children", "placement", "offset", "preventOverflow", "boundariesDetectionDebounce", "overflowBoundaries", "arrow", "arrowOffset", "getPopper", "lazyInit", "zIndex", "disableToggleClose", "popoverClassName", "popoverStyle", "className", "popoverId", "captureOptions", "preventAroundOverflow", "getContainer", "theme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Tooltip
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import React, { useMemo, useState } from 'react';
import { guid } from '@tencent/glue-util-helper';
import { Popper } from '../Popper';
import { ViewPopoverTrigger } from '../../views/ViewPopoverTrigger';
import { TooltipContent } from './TooltipContent';
var ClickTrigger = Popper.withClickTrigger(ViewPopoverTrigger);
var HoverTrigger = Popper.withHoverTrigger(ViewPopoverTrigger);
export function Tooltip(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      onVisibleChange = _useState2[1];

  var _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
      showDelay = props.showDelay,
      hideDelay = props.hideDelay,
      children = props.children,
      placement = props.placement,
      offset = props.offset,
      preventOverflow = props.preventOverflow,
      boundariesDetectionDebounce = props.boundariesDetectionDebounce,
      overflowBoundaries = props.overflowBoundaries,
      _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? true : _props$arrow,
      arrowOffset = props.arrowOffset,
      getPopper = props.getPopper,
      _props$lazyInit = props.lazyInit,
      lazyInit = _props$lazyInit === void 0 ? true : _props$lazyInit,
      zIndex = props.zIndex,
      disableToggleClose = props.disableToggleClose,
      popoverClassName = props.popoverClassName,
      popoverStyle = props.popoverStyle,
      className = props.className,
      popoverId = props.popoverId,
      captureOptions = props.captureOptions,
      preventAroundOverflow = props.preventAroundOverflow,
      getContainer = props.getContainer,
      theme = props.theme,
      extra = _objectWithoutProperties(props, _excluded);

  var triggerOpts = _objectSpread({
    className: className,
    disableToggleClose: disableToggleClose
  }, extra);

  var popoverOpts = {
    show: show,
    placement: placement,
    offset: offset,
    preventOverflow: preventOverflow,
    boundariesDetectionDebounce: boundariesDetectionDebounce,
    overflowBoundaries: overflowBoundaries,
    arrow: arrow,
    arrowOffset: arrowOffset,
    getPopper: getPopper,
    lazyInit: lazyInit,
    zIndex: zIndex,
    style: popoverStyle,
    className: popoverClassName,
    popoverId: popoverId,
    onVisibleChange: onVisibleChange,
    captureOptions: captureOptions,
    preventAroundOverflow: preventAroundOverflow,
    getContainer: getContainer,
    theme: theme
  };
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  return React.createElement(Popper, null, React.createElement(Popper.TriggerGroup, {
    triggerGroupId: triggerId
  }, trigger === 'click' && React.createElement(ClickTrigger, _objectSpread({}, triggerOpts), children), trigger === 'hover' && React.createElement(HoverTrigger, _objectSpread(_objectSpread({}, triggerOpts), {}, {
    showDelay: showDelay,
    hideDelay: hideDelay
  }), children)), React.createElement(TooltipContent, _objectSpread(_objectSpread({}, popoverOpts), {}, {
    triggerIds: triggerIds
  })));
}